import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3803_53588)">
      <rect y={4} width={32} height={24} rx={4} fill="white" />
      <rect
        x={0.5}
        y={4.5}
        width={31}
        height={23}
        rx={3.5}
        stroke="#161C24"
        strokeOpacity={0.1}
      />
      <path
        d="M17.0027 12C15.8971 12 15 12.8835 15 13.974C15 15.1334 15.8581 16 17.0027 16C18.1188 16 19 15.1219 19 13.9968C19 12.8783 18.1247 12 17.0027 12Z"
        fill="url(#paint0_linear_3803_53588)"
      />
      <path
        d="M4.18886 12.0861H3V15.9025H4.18265C4.81015 15.9025 5.26395 15.7657 5.66205 15.4622C6.13438 15.1016 6.41448 14.558 6.41448 13.9961C6.41448 12.8694 5.49991 12.0861 4.18886 12.0861ZM5.13434 14.9524C4.87872 15.1647 4.5496 15.2564 4.02657 15.2564H3.80929V12.7323H4.02657C4.5496 12.7323 4.8661 12.8183 5.13434 13.0412C5.41408 13.2701 5.5809 13.6246 5.5809 13.9907C5.5809 14.3575 5.41408 14.7244 5.13434 14.9524ZM6.78784 15.9025H7.59586V12.0861H6.78794V15.9025H6.78784ZM9.57396 13.55C9.08834 13.3844 8.94544 13.2752 8.94544 13.07C8.94544 12.8294 9.19988 12.6464 9.54866 12.6464C9.79113 12.6464 9.99008 12.7379 10.2021 12.9547L10.6244 12.4462C10.2762 12.1653 9.85971 12.0224 9.40535 12.0224C8.67237 12.0224 8.11233 12.4919 8.11233 13.115C8.11233 13.6419 8.37328 13.9106 9.13212 14.1631C9.44938 14.2656 9.61066 14.3339 9.69171 14.3806C9.85334 14.478 9.93454 14.6148 9.93454 14.7749C9.93454 15.0844 9.66692 15.313 9.30577 15.313C8.92019 15.313 8.60965 15.1358 8.42302 14.8039L7.90131 15.268C8.27365 15.7708 8.72145 15.9948 9.33764 15.9948C10.177 15.9948 10.7674 15.479 10.7674 14.741C10.7674 14.1343 10.4945 13.8594 9.57396 13.55ZM11.0222 13.9962C11.0222 15.119 11.9801 15.9886 13.2116 15.9886C13.5597 15.9886 13.8582 15.9253 14.2254 15.7656V14.8896C13.9016 15.1875 13.6155 15.3074 13.2485 15.3074C12.4341 15.3074 11.8555 14.7636 11.8555 13.9907C11.8555 13.2585 12.4522 12.6805 13.2116 12.6805C13.5965 12.6805 13.8892 12.8063 14.2254 13.1095V12.2336C13.871 12.0682 13.5783 12 13.23 12C12.0048 12 11.0222 12.8872 11.0222 13.9962ZM20.7789 14.6497L19.672 12.0861H18.7889L20.5494 16H20.9843L22.7754 12.086H21.8989L20.7789 14.6496V14.6497ZM23.1431 15.9025H25.4373V15.2564H23.9513V14.2256H25.3804V13.5794H23.9513V12.7323H25.4373V12.0861H23.143V15.9025H23.1431ZM28.6389 13.2124C28.6389 12.4974 28.1048 12.0861 27.1715 12.0861H25.9713V15.9025H26.7804V14.3686H26.8863L28.005 15.9025H29L27.6933 14.2949C28.3036 14.1801 28.6389 13.7965 28.6389 13.2124ZM27.0158 13.8427H26.7804V12.6862H27.0287C27.5335 12.6862 27.807 12.8814 27.807 13.2528C27.807 13.6359 27.5335 13.8427 27.0158 13.8427Z"
        fill="#232021"
      />
      <path
        d="M19.4999 25C24.6999 23.4 29.9999 20.3333 31.9999 19V28H7.34521C9.2301 27.6667 14.2999 26.6 19.4999 25Z"
        fill="#FF6600"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3803_53588"
        x1={15.7766}
        y1={12.3625}
        x2={18.544}
        y2={15.22}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F34F26" />
        <stop offset={1} stopColor="#F69E35" />
      </linearGradient>
      <clipPath id="clip0_3803_53588">
        <rect y={4} width={32} height={24} rx={4} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
